export class LoginData {
    public userId!: string;
    public password!: string;
}
